enum Nutrition {
  CookAtHome = "CookAtHome",
  EatOut = "EatOut",
  LiveWithFamily = "LiveWithFamily",
  Weekends = "Weekends",
  LateNightSnacking = "LateNightSnacking",
}

const nutritionQuestion = {
  name: "nutrition",
  title: "What makes it hardest to stick to your nutrition goals?",
  description: 'Choose any that apply.',
  descriptionLocation: 'underTitle',
  type: "checkbox",
  choices: [
    {
      value: Nutrition.CookAtHome,
      text: `I’m pretty consistent`,
    },
    {
      value: Nutrition.LiveWithFamily,
      text: `I don’t control what I eat`,
    },
    {
      value: Nutrition.EatOut,
      text: `I eat out often`,
    },
    {
      value: Nutrition.Weekends,
      text: `Weekends throw me off`,
    },
    {
      value: Nutrition.LateNightSnacking,
      text: `Evenings are tough`,
    },
  ],
  // showOtherItem: true,
  isRequired: true,
};

const nutritionRestrictionsQuestion = {
  name: "nutritionRestrictions",
  title: "Do you have any dietary restrictions or allergies?",
  description: 'Choose any that apply.',
  descriptionLocation: 'underTitle',
  type: 'checkbox',
  choices: [
    'Vegan',
    'Vegetarian',
    'Gluten Free',
    'Dairy Free',
  ],
  showNoneItem: true,
  // showOtherItem: true,
};

export { Nutrition, nutritionQuestion, nutritionRestrictionsQuestion };
